import { render, staticRenderFns } from "./JobDetailsItem.vue?vue&type=template&id=461d2510&"
import script from "./JobDetailsItem.vue?vue&type=script&lang=js&"
export * from "./JobDetailsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports